import { Story, Knobs, Accents } from '../../DocTypes';

const clientPagingStoryKnobs: Knobs = {
  pagerAccent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n      ',
  },
  pagerAlign: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'left', 'right'],
    delimiter: '\n      ',
  },
  pagerShowFirstLast: { default: '', editor: 'checkbox', delimiter: '\n      ' },
};

export const clientPagingStory: Story = {
  title: 'Client paging',
  description: 'List with client paging',
  coreComponent: {
    html: `<tag-list
  height='250px'
  left-icon='CircleStar'
  left-icon-size='30'
  left-icon-accent='coral'
  primary-field='name'{{pagerAccent}}{{pagerAlign}}{{pagerShowFirstLast}}>
    </tag-list>`,
    knobs: clientPagingStoryKnobs,
    js: `var tagList = document.querySelector('tag-list');
  var data = [
    { name: 'R2-D2' },
    { name: 'C3-PO' },
    { name: 'Luke Skywalker' },
    { name: 'Chewbacca' },
    { name: 'Jabba the Hutt' },
    { name: 'Princess Leia' },
    { name: 'Darth Vader' },
    { name: 'Yoda' },
    { name: 'Han Solo' },
    { name: 'Anakin Skywalker' },
    { name: 'Obi-Wan Kenobi' },
    { name: 'Kylo Ren' },
    { name: 'Rey' },
  ];
  var pageSize = 5;
  var recordCount = data.length;
  var pageCount = Math.ceil(recordCount / pageSize);
  tagList.componentOnReady().then(function() {
    tagList.setData({
      page: 1,
      pageSize: pageSize,
      pageCount: pageCount,
      recordCount: recordCount,
      data: data.slice(0, pageSize),
    });
    tagList.addEventListener('pageRequest', function(e) {
      var page = e.detail.page;
      tagList.setData({
        page: page,
        pageSize: pageSize,
        pageCount: pageCount,
        recordCount: recordCount,
        data: data.slice((page - 1) * pageSize, page * pageSize),
      });
    });
  });
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: clientPagingStoryKnobs,
    parentJSX: `Example = () => {
    const data = [
      { name: 'R2-D2' },
      { name: 'C3-PO' },
      { name: 'Luke Skywalker' },
      { name: 'Chewbacca' },
      { name: 'Jabba the Hutt' },
      { name: 'Princess Leia' },
      { name: 'Darth Vader' },
      { name: 'Yoda' },
      { name: 'Han Solo' },
      { name: 'Anakin Skywalker' },
      { name: 'Obi-Wan Kenobi' },
      { name: 'Kylo Ren' },
      { name: 'Rey' },
    ];
    const pageSize = 5;
    const [page, setPage] = React.useState(1);

    const pageOfData = data.slice(
      (page - 1) * pageSize,
      page * pageSize,
    );

    const recordCount = data.length;
    const pageCount = Math.ceil(recordCount / pageSize);

    return (
      <TagList
        height='250px'
        leftIcon='CircleStar'
        leftIconSize='30'
        leftIconAccent='coral'
        primaryField='name'
        data={pageOfData}
        page={page}
        pageSize={pageSize}
        pageCount={pageCount}
        onPageRequest={(e) => setPage(e.detail.page)}{{pagerAccent}}{{pagerAlign}}{{pagerShowFirstLast}}
      />
    )
  };
  `,
  },
};
